<template>
  <el-dialog
    title="选择会员"
    :visible.sync="visible"
    width="76%"
    append-to-body
    :close-on-click-modal="false"
    @open="load"
  >
    <div class="filter-container">
      <el-input
        v-model.trim="query.keyword"
        clearable
        placeholder="账号/姓名/手机号"
        style="width:240px"
        @keyup.enter.native="search"
      />
      <el-input
        v-model.trim="query.userId"
        clearable
        placeholder="会员ID"
        style="width:150px"
        @keyup.enter.native="search"
      />
      <el-select v-model="query.gradeId" clearable placeholder="会员等级"
        ><el-option v-for="g in grades" :key="g.id" :label="g.name" :value="g.id"
      /></el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <el-table
      ref="table"
      v-loading="loading"
      :data="list"
      row-key="id"
      border
      @selection-change="selectPage"
    >
      <el-table-column type="selection" width="48" :reserve-selection="true" />
      <el-table-column prop="id" label="会员ID" width="110" />
      <el-table-column prop="nickname" label="昵称" min-width="140"
        ><template slot-scope="s">{{
          s.row.nickname || s.row.name || "-"
        }}</template></el-table-column
      >
      <el-table-column prop="mobile" label="手机号" min-width="140" />
      <el-table-column prop="gradeName" label="等级" width="120" />
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :current-page="query.page"
      :page-size="query.pageSize"
      :page-sizes="[10, 20, 30, 50]"
      @current-change="changePage"
      @size-change="changeSize"
    />
    <span slot="footer"
      ><span class="selected-count">已选择 {{ selected.length }} 人</span
      ><el-button @click="visible = false">取消</el-button
      ><el-button type="primary" @click="confirm">确定</el-button></span
    >
  </el-dialog>
</template>
<script>
import { getMemberList } from "@/api/member";
import { getGradeList } from "@/api/system";
export default {
  props: { value: Boolean, selectedRows: { type: Array, default: () => [] } },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      grades: [],
      selected: [],
      query: { page: 1, pageSize: 10, keyword: "", userId: "", gradeId: null }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    selectedRows: {
      immediate: true,
      deep: true,
      handler(v) {
        this.selected = (v || []).slice();
      }
    }
  },
  methods: {
    async load() {
      this.selected = (this.selectedRows || []).slice();
      const gr = await getGradeList();
      this.grades = gr.data || [];
      await this.fetch();
      this.restore();
    },
    async fetch() {
      this.loading = true;
      try {
        const r = await getMemberList(this.query);
        const d = r.data || {};
        this.list = d.entitys || [];
        this.total = d.totalCount || 0;
      } finally {
        this.loading = false;
      }
    },
    restore() {
      this.$nextTick(() =>
        this.list.forEach(row => {
          if (this.selected.some(v => String(v.id) === String(row.id)))
            this.$refs.table.toggleRowSelection(row, true);
        })
      );
    },
    selectPage(rows) {
      const ids = this.list.map(v => String(v.id));
      this.selected = this.selected.filter(v => !ids.includes(String(v.id))).concat(rows);
    },
    search() {
      this.query.page = 1;
      this.fetch().then(this.restore);
    },
    changePage(v) {
      this.query.page = v;
      this.fetch().then(this.restore);
    },
    changeSize(v) {
      this.query.pageSize = v;
      this.query.page = 1;
      this.fetch().then(this.restore);
    },
    confirm() {
      this.$emit("confirm", this.selected.slice());
      this.visible = false;
    }
  }
};
</script>
<style scoped>
.filter-container {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.el-pagination {
  margin-top: 16px;
  text-align: right;
}
.selected-count {
  float: left;
  line-height: 36px;
  color: #606266;
}
</style>
